'use client'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { initializeAddressState } from '../reduxToolkit/addressSlice'

const AddressStateInitializer = ({ organizationData, checkoutAddress }) => {
  const dispatch = useDispatch()
  const { isLoggedin } = useSelector((state) => state.auth)
  useEffect(() => {
    if (organizationData) {
      dispatch(
        initializeAddressState({
          organizationData,
          checkoutAddress: checkoutAddress || {},
          isLoggedin,
        })
      )
    }
  }, [organizationData, checkoutAddress, dispatch, isLoggedin])

  return null
}

export default AddressStateInitializer
